import React from 'react';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}
export function GlassCard({
  children,
  className = ''
}: GlassCardProps) {
  return <div className={`backdrop-blur-xl bg-white/20 border border-white/30 rounded-3xl shadow-2xl ${className}`} data-id="element-38">
      {children}
    </div>;
}